/* eslint-disable no-unused-vars */
/* eslint-disable */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import closeSvg from 'src/assets/close.svg';
import { DateTime } from 'luxon';
import {
  CommonDropdown,
  CommonInput,
  CustomCheckBox,
  DatePicker,
  FormErrorWrap,
  FullScreenLoading,
  ICommonDropdownOption,
  RegularButton,
} from 'pg-ui-library';
import ReactModal from 'react-modal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { Gender, IDependent, MaritalStatus, RelationshipType } from 'src/interfaces';
import { phoneRegExp } from 'src/utils/phoneRegex';
import { useActions } from 'src/hooks/useActions';
import {
  CloseIcon,
  DependentsForm,
  FormInputWrapper,
  ActionWrapper,
  DependentsForms,
  HeadingShow,
  WarningEditMessage,
} from './styles';
import { useAddDependent, useUpdateDependent } from '../../mutations/add-delete-update-dependent.mutation';
import { genderOptions, relationshipOptions } from '../..';

export enum FormPages {
  // eslint-disable-next-line no-unused-vars
  PERSONAL = 'Personal',
  ADDRESS = 'Address',
}

const PersonalDependentsForm: React.FC<{ dependentUpdate: IDependent[]; onSuccess: () => void; isUpdate: boolean }> = ({
  dependentUpdate,
  onSuccess,
  isUpdate,
}) => {
  const { t } = useTranslation();
  const [formState, setFormState] = useState(FormPages.PERSONAL);
  const addDependentToEmploye = useAddDependent();
  const updateDependentToEmployee = useUpdateDependent();
  const { getPersonalInfo } = useActions();
  const { data } = useTypedSelector(state => state.personalInfo);
  const [contactId, setContactId] = useState('');
  const [allowEditDelete, setAllowEditDelete] = useState(true);
  const [editingFields, setEditingFields] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (dependentUpdate[0]?.id) {
      setContactId(dependentUpdate[0]?.id);
      if (dependentUpdate[0]?.notAllowedEditionAndDelition) {
        setAllowEditDelete(false);
      }
    } else {
      setAllowEditDelete(true);
    }
  }, [isUpdate]);

  const validationSchema = yup.object({
    firstName: yup.string().max(255).required(),
    middleName: yup.string().max(255),
    lastName: yup.string().max(255).required(),
    workPhone: yup.string().max(14).matches(phoneRegExp, t('global.form.invalidPhone')),
    homePhone: yup.string().max(14).matches(phoneRegExp, t('global.form.invalidPhone')),
    email: yup.string().email(),
    gender: yup.string().nullable().required(),
    birthDate: yup.string().nullable().required(),
    ssn: yup
      .string()
      .length(9, 'SSN must be exactly nine-digit number')
      .matches(/^\d+$/, 'SSN is required only numeric digits')
      .required(),
    zipCode: yup
      .string()
      .length(5, 'Zip Code must be exactly five-digit number')
      .matches(/^\d+$/, 'Zip Code is required only numeric digits'),
  });

  function mapRelationshipType(key: string): RelationshipType {
    switch (key) {
      case 'Spouse':
        return RelationshipType.SPOUSE;
      case 'Son':
        return RelationshipType.SON;
      case 'Husband':
        return RelationshipType.HUSBAND;
      case 'N/A':
        return RelationshipType.NOT_APPLICABLE;
      case 'Daughter':
        return RelationshipType.DAUGHTER;
      case 'Family':
        return RelationshipType.Family;
      case 'Parent':
        return RelationshipType.Parent;
      case 'Sibling':
        return RelationshipType.Sibling;
      case 'domestic_partner':
        return RelationshipType.DOMESTIC_PARTNER;
      case 'ex_spouse':
        return RelationshipType.EX_SPOUSE;
      case 'FamilyContact':
        return RelationshipType.FAMILY_CONTACT;
      case 'other_contact':
        return RelationshipType.OTHER_CONTACT;
      case 'Child':
        return RelationshipType.CHILD;
      case 'Domestic Partner':
        return RelationshipType.DOMESTIC_PARTNER_LABEL;
      case 'Ex spouse':
        return RelationshipType.EX_SPOUSE_LABEL;
      case 'Family Contact':
        return RelationshipType.FAMILY_CONTACT_LABEL;
      case 'Other Contact':
        return RelationshipType.OTHER_CONTACT_LABEL;
      default:
        return RelationshipType.NOT_APPLICABLE;
    }
  }

  const maskSensitiveData = (value: string | undefined | null, fieldName: string): string => {
    if (!value || !isUpdate || editingFields.has(fieldName)) return value || '';
    if (value.length <= 4) return '****';
    return '****' + value.substring(4);
  };

  const maskDate = (date: Date | string | undefined | null, fieldName: string): string => {
    if (!date || !isUpdate || editingFields.has(fieldName)) {
      if (date instanceof Date) {
        return DateTime.fromJSDate(date).toFormat('MM/dd/yyyy');
      }
      return date || '';
    }
    let dateStr = '';
    if (date instanceof Date) {
      dateStr = DateTime.fromJSDate(date).toFormat('MM/dd/yyyy');
    } else if (typeof date === 'string') {
      dateStr = date;
    } else {
      return '';
    }
    if (dateStr.length <= 4) return '****';
    return '****' + dateStr.substring(4);
  };

  const handleFieldFocus = (fieldName: string) => {
    if (isUpdate && !editingFields.has(fieldName)) {
      setEditingFields(prev => new Set(prev).add(fieldName));
      formik.setFieldValue(fieldName, '');
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: isUpdate ? dependentUpdate[0]?.firstName || '' : '',
      middleName: isUpdate ? dependentUpdate[0]?.middleName || '' : '',
      lastName: isUpdate ? dependentUpdate[0]?.lastName || '' : '',
      ssn: isUpdate ? dependentUpdate[0]?.ssn || '' : '',
      workPhone: isUpdate ? dependentUpdate[0]?.workPhone || '' : '',
      homePhone: isUpdate ? dependentUpdate[0]?.homePhone || '' : '',
      email: isUpdate ? dependentUpdate[0]?.email || '' : '',
      city: isUpdate ? dependentUpdate[0]?.city || '' : '',
      address: isUpdate ? dependentUpdate[0]?.address || '' : '',
      state: isUpdate ? dependentUpdate[0]?.state || '' : '',
      zipCode: isUpdate ? dependentUpdate[0]?.zipCode || '' : '',
      country: isUpdate ? dependentUpdate[0]?.country || '' : 'USA',
      county: isUpdate ? dependentUpdate[0]?.county || '' : '',
      notes: isUpdate ? dependentUpdate[0]?.notes || '' : '',
      birthDate: isUpdate && dependentUpdate[0]?.birthDate ? new Date(dependentUpdate[0].birthDate) : '',
      relationshipType:
        isUpdate && dependentUpdate[0]?.relationship
          ? mapRelationshipType(dependentUpdate[0]?.relationship)
          : RelationshipType.HUSBAND,
      gender: isUpdate ? dependentUpdate[0]?.gender || '' : '',
      isPersonalContact: true,
      isEmergencyContact: isUpdate ? dependentUpdate[0]?.isEmergencyContact || false : false,
      isBeneficiary: isUpdate ? dependentUpdate[0]?.isBeneficiary || false : false,
      isDependent: isUpdate ? dependentUpdate[0]?.isDependent || false : false,
      studentStatus: isUpdate ? dependentUpdate[0]?.studentStatus || false : false,
      smokerStatus: isUpdate ? dependentUpdate[0]?.smokerStatus || false : false,
    },
    validationSchema,
    onSubmit: async (values: IDependent) => {
      try {
        // Garantir que valores mascarados não sejam enviados - os valores do formik já são reais
        // mas adicionamos verificação de segurança
        const cleanValues: IDependent = { ...values };
        const fieldsToClean: (keyof IDependent)[] = ['ssn', 'workPhone', 'homePhone', 'email'];

        fieldsToClean.forEach(field => {
          const value = cleanValues[field];
          if (typeof value === 'string' && value.includes('****')) {
            // Se o valor contém máscara, usar o valor original do dependentUpdate se existir
            if (isUpdate && dependentUpdate[0]?.[field]) {
              (cleanValues as any)[field] = dependentUpdate[0][field];
            } else {
              (cleanValues as any)[field] = '';
            }
          }
        });

        const formData = {
          dependent: {
            ...cleanValues,
            birthDate:
              cleanValues.birthDate instanceof Date
                ? DateTime.fromJSDate(cleanValues.birthDate).toFormat('M/d/yyyy')
                : '',
          },
          personnelNumber: data.personalInfo?.employeeNickId ?? '',
        };
        formData.dependent.personnelNumber = data.personalInfo?.employeeNickId ?? '';
        if (isUpdate) {
          formData.dependent.id = contactId;
          await updateDependentToEmployee.mutateAsync(formData);
          getPersonalInfo();
          onSuccess();
        } else {
          await addDependentToEmploye.mutateAsync(formData);
          getPersonalInfo();
          onSuccess();
        }
      } catch (error) {
        console.error('Error during form Updation', error);
      }
    },
  });

  return (
    <>
      {isUpdate ? <HeadingShow>Update Relationship</HeadingShow> : <HeadingShow>Add Relationship</HeadingShow>}
      {(addDependentToEmploye.isLoading || updateDependentToEmployee.isLoading) && <FullScreenLoading />}
      <DependentsForms>
        <DependentsForm onSubmit={formik.handleSubmit} style={{ padding: '20px 7% 20px 20px' }}>
          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            <CommonInput
              id="firstName"
              name="firstName"
              label="First Name*"
              placeholder="First Name"
              value={formik.values.firstName}
              onChange={event => {
                const input = event.target.value;
                if (/^[A-Za-z]*$/.test(input) || input === '') {
                  formik.setFieldValue('firstName', input);
                }
              }}
              disabled={!allowEditDelete}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.firstName as string} visible={!!formik.errors.firstName} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            <CommonInput
              id="middleName"
              name="middleName"
              label="Middle Name"
              placeholder="Middle Name"
              value={formik.values.middleName}
              onChange={event => {
                const input = event.target.value;
                if (/^[A-Za-z]*$/.test(input) || input === '') {
                  formik.setFieldValue('middleName', input);
                }
              }}
              disabled={!allowEditDelete}
              style={{ width: '100%' }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            <CommonInput
              id="lastName"
              name="lastName"
              label="Last Name*"
              placeholder="Last Name"
              value={formik.values.lastName}
              onChange={event => {
                const input = event.target.value;
                if (/^[A-Za-z]*$/.test(input) || input === '') {
                  formik.setFieldValue('lastName', input);
                }
              }}
              disabled={!allowEditDelete}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.lastName as string} visible={!!formik.errors.lastName} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            <CommonDropdown
              label="Relationship"
              id="relationshipType"
              name="relationshipType"
              options={relationshipOptions}
              value={formik.values.relationshipType}
              setValue={(value: string) => formik.setFieldValue('relationshipType', value)}
              disabled={!allowEditDelete}
              selectStyle={{
                width: '100%',
                maxWidth: '100%',
              }}
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(17% - 20px)' }}>
            <CommonDropdown
              label="Gender*"
              id="gender"
              name="gender"
              options={genderOptions}
              value={formik.values.gender}
              setValue={(value: string) => formik.setFieldValue('gender', value)}
              disabled={!allowEditDelete}
              selectStyle={{
                width: '100%',
                maxWidth: '100%',
                marginTop: '8px',
                height: 'auto',
              }}
            />
            <FormErrorWrap errorMessage={formik.errors.gender as string} visible={!!formik.errors.gender} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            <CommonInput
              id="ssn"
              name="ssn"
              label="SSN"
              placeholder="SSN"
              value={maskSensitiveData(formik.values.ssn, 'ssn')}
              onFocus={() => handleFieldFocus('ssn')}
              onChange={event => {
                const ssnValue = event.target.value.replace(/\D/g, '').substring(0, 9);
                formik.setFieldValue('ssn', ssnValue);
              }}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.ssn as string} visible={!!formik.errors.ssn} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            {isUpdate && formik.values.birthDate && !editingFields.has('birthDate') ? (
              <CommonInput
                id="birthDate"
                name="birthDate"
                label="Birth Date*"
                placeholder="Birth Date"
                value={maskDate(formik.values.birthDate, 'birthDate')}
                onFocus={() => {
                  if (allowEditDelete) {
                    handleFieldFocus('birthDate');
                  }
                }}
                disabled={!allowEditDelete}
                style={{ width: '100%' }}
              />
            ) : (
              <DatePicker
                id="birthDate"
                name="birthDate"
                label="Birth Date*"
                dateFormat="MM/dd/yyyy"
                maxDate={new Date()}
                selected={formik.values.birthDate as Date}
                onChange={(val: Date) => {
                  if (isUpdate && !editingFields.has('birthDate')) {
                    handleFieldFocus('birthDate');
                  }
                  formik.setFieldValue('birthDate', val);
                }}
                disabled={!allowEditDelete}
              />
            )}
            <FormErrorWrap errorMessage={formik.errors.birthDate as string} visible={!!formik.errors.birthDate} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(17% - 20px)' }}>
            <CommonInput
              id="workPhone"
              name="workPhone"
              label="Work Phone"
              placeholder="Work Phone"
              value={maskSensitiveData(formik.values.workPhone, 'workPhone')}
              onFocus={() => handleFieldFocus('workPhone')}
              onChange={event => {
                const inputValue = event.target.value;
                const formattedValue = inputValue
                  .replace(/[^\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g, '')
                  .substring(0, 14);
                formik.setFieldValue('workPhone', formattedValue);
              }}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.workPhone as string} visible={!!formik.errors.workPhone} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 calc(17% - 20px)' }}>
            <CommonInput
              id="homePhone"
              name="homePhone"
              label="Home Phone"
              placeholder="Home Phone"
              value={maskSensitiveData(formik.values.homePhone, 'homePhone')}
              onFocus={() => handleFieldFocus('homePhone')}
              onChange={event => {
                const inputValue = event.target.value;
                const formattedValue = inputValue
                  .replace(/[^\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g, '')
                  .substring(0, 14);
                formik.setFieldValue('homePhone', formattedValue);
              }}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.homePhone as string} visible={!!formik.errors.homePhone} />
          </FormInputWrapper>
          <div style={{ width: '40%', marginLeft: '-10%' }}>
            <FormInputWrapper style={{ maxWidth: '382px' }}>
              <CommonInput
                id="email"
                name="email"
                label="Email"
                placeholder="Email"
                value={maskSensitiveData(formik.values.email, 'email')}
                onFocus={() => handleFieldFocus('email')}
                onChange={event => formik.setFieldValue('email', event.target.value)}
                style={{ width: '100%' }}
              />
            </FormInputWrapper>
          </div>

          <div style={{ width: '43%' }}>
            <div style={{ width: '100%', marginRight: '-52%', display: 'flex', marginTop: '7%' }}>
              <FormInputWrapper style={{ maxWidth: '20%', marginRight: '14%' }}>
                <CustomCheckBox
                  label="Dependent"
                  id="isDependent"
                  name="isDependent"
                  checked={formik.values.isDependent}
                  onChange={() => {
                    formik.setFieldValue('isDependent', !formik.values.isDependent);
                  }}
                  disabled={!allowEditDelete}
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ maxWidth: '20%', marginRight: '14%' }}>
                <CustomCheckBox
                  label="Beneficiary"
                  id="isBeneficiary"
                  name="isBeneficiary"
                  checked={formik.values.isBeneficiary}
                  onChange={() => {
                    formik.setFieldValue('isBeneficiary', !formik.values.isBeneficiary);
                  }}
                  disabled={!allowEditDelete}
                />
              </FormInputWrapper>

              <FormInputWrapper style={{ minWidth: '40%' }}>
                <CustomCheckBox
                  label="Emergency Contact"
                  id="isEmergencyContact"
                  name="isEmergencyContact"
                  checked={formik.values.isEmergencyContact}
                  onChange={() => {
                    formik.setFieldValue('isEmergencyContact', !formik.values.isEmergencyContact);
                  }}
                  disabled={!allowEditDelete}
                />
              </FormInputWrapper>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginRight: '16%' }}>
            <FormInputWrapper style={{ flex: '0 0 calc(37% - 20px)' }}>
              <CommonInput
                id="address"
                name="address"
                label="Address"
                placeholder="Address"
                value={formik.values.address}
                onChange={event => formik.setFieldValue('address', event.target.value)}
                style={{ width: '150%' }}
                disabled={!allowEditDelete}
              />
              <FormErrorWrap errorMessage={formik.errors.address as string} visible={!!formik.errors.address} />
            </FormInputWrapper>
            <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)', marginLeft: '25%' }}>
              <CommonInput
                id="city"
                name="city"
                label="City"
                placeholder="City"
                value={formik.values.city}
                onChange={event => formik.setFieldValue('city', event.target.value)}
                style={{ width: '150%' }}
                disabled={!allowEditDelete}
              />
              <FormErrorWrap errorMessage={formik.errors.city as string} visible={!!formik.errors.city} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)', marginLeft: '15%' }}>
              <CommonInput
                id="state"
                name="state"
                label="State"
                placeholder="State"
                value={formik.values.state}
                onChange={event => {
                  const input = event.target.value;
                  if (/^[A-Za-z]*$/.test(input) || input === '') {
                    formik.setFieldValue('state', input);
                  }
                }}
                disabled={!allowEditDelete}
                style={{ width: '150%' }}
              />
              <FormErrorWrap errorMessage={formik.errors.state as string} visible={!!formik.errors.state} />
            </FormInputWrapper>
          </div>
          <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)' }}>
            <CommonInput
              id="zipCode"
              name="zipCode"
              label="Zip Code"
              placeholder="Zip Code"
              value={formik.values.zipCode}
              onChange={event => {
                const zipCodeValue = event.target.value.replace(/\D/g, '').substring(0, 5);
                formik.setFieldValue('zipCode', zipCodeValue);
              }}
              disabled={!allowEditDelete}
              style={{ width: '100%' }}
            />
            <FormErrorWrap errorMessage={formik.errors.zipCode as string} visible={!!formik.errors.zipCode} />
          </FormInputWrapper>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginRight: '39.5%',
              marginLeft: '3%',
            }}
          >
            <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)', marginRight: '10%' }}>
              <CommonInput
                id="county"
                name="county"
                label="County"
                placeholder="County"
                value={formik.values.county}
                onChange={event => formik.setFieldValue('county', event.target.value)}
                style={{ width: '140%' }}
                disabled={!allowEditDelete}
              />
              <FormErrorWrap errorMessage={formik.errors.county as string} visible={!!formik.errors.county} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '0 0 calc(25% - 20px)', marginRight: '10%' }}>
              <CommonInput
                id="country"
                name="country"
                label="Country"
                placeholder="Country"
                value={formik.values.country}
                onChange={event => formik.setFieldValue('country', event.target.value)}
                style={{ width: '140%' }}
                disabled={!allowEditDelete}
              />
              <FormErrorWrap errorMessage={formik.errors.country as string} visible={!!formik.errors.country} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '0 0 calc(38% - 20px)' }}>
              <CommonInput
                id="notes"
                name="notes"
                label="Notes"
                placeholder="Notes"
                value={formik.values.notes}
                onChange={event => formik.setFieldValue('notes', event.target.value)}
                style={{ width: '180%' }}
              />
              <FormErrorWrap errorMessage={formik.errors.notes as string} visible={!!formik.errors.notes} />
            </FormInputWrapper>
            <div style={{ width: '100%', marginLeft: '40%', marginTop: '5.5%' }}>
              <div style={{ width: '100%', marginLeft: '22px', display: 'flex' }}>
                <FormInputWrapper style={{ maxWidth: '14%', marginRight: '60%', marginLeft: '-30%' }}>
                  <CustomCheckBox
                    label="Student"
                    id="studentStatus"
                    name="studentStatus"
                    checked={formik.values.studentStatus}
                    onChange={() => {
                      formik.setFieldValue('studentStatus', !formik.values.studentStatus);
                    }}
                    disabled={!allowEditDelete}
                  />
                </FormInputWrapper>

                <FormInputWrapper>
                  <CustomCheckBox
                    label="Smoker"
                    id="smokerStatus"
                    name="smokerStatus"
                    checked={formik.values.smokerStatus}
                    onChange={() => {
                      formik.setFieldValue('smokerStatus', !formik.values.smokerStatus);
                    }}
                    disabled={!allowEditDelete}
                  />
                </FormInputWrapper>
              </div>
            </div>
          </div>

          <FormInputWrapper />
        </DependentsForm>
        <ActionWrapper>
          {!allowEditDelete && (
            <WarningEditMessage>
              Note: The dependent is already enrolled in benefits; only the enabled field can be updated.
            </WarningEditMessage>
          )}
          {isUpdate ? (
            <RegularButton
              type="button"
              onClick={() => formik.handleSubmit()}
              disabled={!formik.isValid && updateDependentToEmployee.isLoading}
            >
              {t('global.form.update')}
            </RegularButton>
          ) : (
            <RegularButton
              type="button"
              onClick={() => formik.handleSubmit()}
              disabled={!formik.isValid || addDependentToEmploye.isLoading}
            >
              {t('global.form.save')}
            </RegularButton>
          )}
        </ActionWrapper>
      </DependentsForms>
    </>
  );
};

export const PersonalDependentsModal: React.FC<{
  updateDependent: IDependent[];
  isOpen: boolean;
  setIsOpen: Function;
  isUpdate: boolean;
}> = ({ updateDependent, isOpen, setIsOpen, isUpdate }) => {
  const modalRef = useRef(null);
  const updateDependentToEmployee = useUpdateDependent();

  const handleModalClose = () => {
    setIsOpen(false);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '10px',
          background: '#f3f4f8',
          margin: 'auto',
          maxWidth: '1200px',
          minWidth: '1200px',
          height: '645px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
      }}
      onRequestClose={handleModalClose}
      // eslint-disable-next-line no-return-assign
      contentRef={(node: any) => (modalRef.current = node)}
    >
      <CloseIcon src={closeSvg} onClick={handleModalClose} />
      <PersonalDependentsForm dependentUpdate={updateDependent} onSuccess={handleModalClose} isUpdate={isUpdate} />
    </ReactModal>
  );
};
